
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.702 6.359a.75.75 0 00-1.06-1.06l-6.172 6.17a.747.747 0 000 1.061l6.171 6.172a.75.75 0 101.06-1.06l-4.89-4.892H21a.75.75 0 000-1.5H4.81l4.892-4.891z"}})])
          )
        }
      }
    